export default `
mutation DenyCoverage($shiftId: ID!, $deniedBy: ID!) {
  denyCoverage(shiftId: $shiftId, deniedBy: $deniedBy) {
    createdAt
    updatedAt
    publishedAt
    acknowledgedAt
    updatedBy
    shiftId
    status
    createdBy
    userId
    isDeleted
    propertyId
    note
    startTime
    endTime
    serviceProviderId
    requests
    divisionId
    requiredLevels
    timezone
  }
}
`;